import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontSize: '1.8rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

export const Header: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Typography variant="h1" className={classes.title}>
      {t('policyInfoAndRates:policy-info-and-rates')}
    </Typography>
  );
};
